// Post-signup welcome walkthrough (Sam, Oct 22 2026 8:11 PM). Client-only sessionStorage.
export const WELCOME_PENDING_KEY = 'slWelcomePending';
export const WELCOME_QUEUE_KEY = 'slWelcomeQueue';
export const WELCOME_ORDER = ['talk', 'learn', 'listen', 'teach'];
export const WELCOME_ROUTES = {
  talk: { name: 'ForTalkersPage', path: '/for-talkers', label: 'Chat with Someone' },
  learn: { name: 'LearnPage', path: '/learn', label: 'Learn Something New' },
  listen: { name: 'BecomeAListenerPage', path: '/become-a-listener', label: 'Listener setup' },
  teach: { name: 'TeachPage', path: '/teach', label: 'Teach setup' },
};
const ss = () => (typeof window !== 'undefined' && window.sessionStorage ? window.sessionStorage : null);
export const markWelcomePending = role => { try { ss()?.setItem(WELCOME_PENDING_KEY, role || 'both'); } catch (e) {} };
export const welcomePendingRole = () => { try { return ss()?.getItem(WELCOME_PENDING_KEY) || null; } catch (e) { return null; } };
export const clearWelcome = () => { try { ss()?.removeItem(WELCOME_PENDING_KEY); ss()?.removeItem(WELCOME_QUEUE_KEY); } catch (e) {} };
export const startWelcomeQueue = picks => {
  const queue = WELCOME_ORDER.filter(k => picks.includes(k));
  try { ss()?.removeItem(WELCOME_PENDING_KEY); ss()?.setItem(WELCOME_QUEUE_KEY, JSON.stringify({ queue, i: 0 })); } catch (e) {}
  return queue;
};
export const readWelcomeQueue = () => { try { return JSON.parse(ss()?.getItem(WELCOME_QUEUE_KEY) || 'null'); } catch (e) { return null; } };
export const advanceWelcomeQueue = () => {
  const q = readWelcomeQueue(); if (!q) return null;
  const next = { ...q, i: q.i + 1 };
  if (next.i >= q.queue.length) { clearWelcome(); return null; }
  try { ss()?.setItem(WELCOME_QUEUE_KEY, JSON.stringify(next)); } catch (e) {}
  return next;
};
